import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import {useEffect, useRef, useState} from 'react';
import {Button} from '@/components/ui/button';

// Opaque rectangles are burned into the exported pixels; original files are never uploaded.
export default function SupportEvidence({item, onRemove}) {
  useUiLanguage();
  const canvas = useRef(null), start = useRef(null), image = useRef(null);
  const [rectangles, setRectangles] = useState([]);
  useEffect(() => {
    let active = true;
    const source = new Image();
    source.onload = () => {
      if (!active) return;
      image.current = source;
      const scale = Math.min(1, 2000/Math.max(source.width, source.height));
      canvas.current.width = Math.round(source.width*scale); canvas.current.height = Math.round(source.height*scale);
      canvas.current.getContext('2d').drawImage(source, 0, 0, canvas.current.width, canvas.current.height);
      item.canvas = canvas.current;
    };
    source.onerror = () => {if(active) onRemove(item.id);};
    source.src = item.url;
    return () => {active=false;};
  }, [item, onRemove]);
  useEffect(() => {
    if (!image.current || !canvas.current) return;
    const c=canvas.current, ctx=c.getContext('2d');
    ctx.drawImage(image.current,0,0,c.width,c.height);ctx.fillStyle='#000000';
    rectangles.forEach(r=>ctx.fillRect(...r));
  },[rectangles]);
  const point=e=>{const r=canvas.current.getBoundingClientRect();return [(e.clientX-r.left)*canvas.current.width/r.width,(e.clientY-r.top)*canvas.current.height/r.height];};
  return <div className="space-y-2 rounded-xl border p-3">
    <p className="text-xs text-muted-foreground">{tr("Trascina sulla foto per coprire i dati personali con un rettangolo nero.")}</p>
    <canvas ref={canvas} aria-label={tr("Anteprima allegato: trascina per oscurare")} className="mx-auto max-h-96 max-w-full touch-none cursor-crosshair"
      onPointerDown={e=>{start.current=point(e);e.currentTarget.setPointerCapture(e.pointerId);}}
      onPointerUp={e=>{if(!start.current)return;const end=point(e), origin=start.current;start.current=null;
        setRectangles(rs=>[...rs,[Math.min(origin[0],end[0]),Math.min(origin[1],end[1]),Math.max(8,Math.abs(end[0]-origin[0])),Math.max(8,Math.abs(end[1]-origin[1]))]]);}}
      onPointerCancel={()=>{start.current=null;}}/>
    <div className="flex flex-wrap gap-2"><Button type="button" size="sm" variant="outline" disabled={!rectangles.length} onClick={()=>setRectangles(rs=>rs.slice(0,-1))}>{tr("Annulla ultima copertura")}</Button>
      <Button type="button" size="sm" variant="ghost" onClick={()=>onRemove(item.id)}>{tr("Rimuovi foto")}</Button></div>
  </div>;
}
